var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        title: _vm.$t("seller.process"),
        visible: _vm.handleDialog,
        width: "500px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.handleDialog = $event
        },
        close: _vm.handleNewCodeDialog,
      },
    },
    [
      _c(
        "div",
        { staticStyle: { padding: "0 20px" } },
        [
          _c(
            "el-form",
            {
              ref: "addFormRef",
              staticClass: "search-form",
              attrs: {
                inline: false,
                model: _vm.handleForm,
                rules: _vm.rules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("seller.processingMethod"),
                            prop: "handlerMethod",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("GlobalSetObj.all"),
                                clearable: "",
                              },
                              model: {
                                value: _vm.handleForm.handlerMethod,
                                callback: function ($$v) {
                                  _vm.$set(_vm.handleForm, "handlerMethod", $$v)
                                },
                                expression: "handleForm.handlerMethod",
                              },
                            },
                            [
                              _c("el-option", {
                                key: "1",
                                attrs: {
                                  label: _vm.$t("seller.resubmit"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                key: "2",
                                attrs: {
                                  label: _vm.$t("seller.rejectRegistration"),
                                  value: 2,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("seller.selectSubmittedInfo"),
                            prop: "resubmitInfo",
                          },
                        },
                        [
                          _c("el-cascader", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              options: _vm.resubmitInfo,
                              props: _vm.props,
                              "show-all-levels": false,
                              clearable: "",
                              "collapse-tags": "",
                              filterable: "",
                            },
                            on: { change: _vm.handlerRsubmitInfoChange },
                            model: {
                              value: _vm.handleForm.resubmitInfo,
                              callback: function ($$v) {
                                _vm.$set(_vm.handleForm, "resubmitInfo", $$v)
                              },
                              expression: "handleForm.resubmitInfo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t("seller.message"),
                            prop: "remarks",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("userManage.pleaseInput"),
                              rows: 3,
                              clearable: "",
                              maxlength: "300",
                              "show-word-limit": "",
                              type: "textarea",
                            },
                            model: {
                              value: _vm.handleForm.remarks,
                              callback: function ($$v) {
                                _vm.$set(_vm.handleForm, "remarks", $$v)
                              },
                              expression: "handleForm.remarks",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c(
                      "div",
                      { staticStyle: { float: "right" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: { click: _vm.handleNewCodeDialog },
                          },
                          [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")) + " ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "primary" },
                            on: { click: _vm.submitForm },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("GlobalSetObj.determine")) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }